import { apiRequest, occtooApiRequest } from "../client/apiClient";
import { EnvironmentConfig } from "../config/environmentConfig";
import { retryRequest } from "../helpers/retryRequest";

export async function fetchClasses(searchString) {
  return retryRequest(() =>
    apiRequest(`/classes${searchString ? `?${searchString}` : ``}`),
  );
}

export async function fetchClassesSimple(searchString) {
  return retryRequest(() =>
    apiRequest(`/classessimple${searchString ? `?${searchString}` : ``}`),
  );
}

export async function fetchOcctooClasses(searchString) {
  return retryRequest(() =>
    occtooApiRequest(
      `/${EnvironmentConfig.occtoo.classesEndpoint}${searchString ? `?${searchString}` : ``}`,
    ),
  );
}

export async function saveClass(kclass) {
  return retryRequest(() =>
    apiRequest("/class/add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(kclass),
    }),
  );
}

export async function editClass(kclass) {
  return retryRequest(() =>
    apiRequest(`/class/edit/${kclass.classCode}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(kclass),
    }),
  );
}
